import { useEffect } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getNotifications, notificationsKey, notificationPath, readNotification } from '../api/notifications.api';

export function useNotifications() {
  return useQuery({
    queryKey: notificationsKey,
    queryFn: getNotifications,
    refetchInterval: 5 * 60 * 1000,
    refetchIntervalInBackground: true,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });
}

export function useReadNotification() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: readNotification,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notificationsKey }),
  });
}



//aggiornamento delle notifiche dopo un determinato evento
export function useReadNotificationsForPath(path: string, enabled: boolean) {
  const queryClient = useQueryClient();
  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    const update = async () => {
      const response = await getNotifications();
      if (cancelled) return;
      const matches = response.list.filter(item => item.read_in === 0 && notificationPath(item.link_at) === notificationPath(path));
      const results = await Promise.allSettled(matches.map(item => readNotification(item.ID)));
      await queryClient.invalidateQueries({ queryKey: notificationsKey });
      if (results.some(result => result.status === 'rejected')) console.error('Errore aggiornamento notifiche email.');
    };
    update().catch(error => console.error('Errore aggiornamento notifiche email:', error));
    return () => { cancelled = true; };
  }, [path, enabled, queryClient]);
}
